module.exports = {
  path: 'pickingList/:fields/:ids/:filters',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/PickingList').default || require('./components/PickingList'));
    }, 'pickinglist');
  }
};



// WEBPACK FOOTER //
// ./routes/pickingList/index.js